import { styled } from '@compiled/react';
import { LoadableAfterPaint } from '@confluence/loadable';
import React from 'react';
import type { EditorClassificationTagWrapperProps } from '../src/EditorComponentsV2/EditorClassificationTagWrapper';

export const EditorClassificationTagWrapper =
	LoadableAfterPaint<EditorClassificationTagWrapperProps>({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-EditorClassificationTagWrapper" */ '../src/EditorComponentsV2/EditorClassificationTagWrapper'
				)
			).EditorClassificationTagWrapper,
		loading: (props) => {
			const { shouldRenderPlaceholder } = props;
			if (!shouldRenderPlaceholder) return null;
			return React.createElement(
				// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
				styled.div({
					height: '26px',
				}),
				{},
				'',
			);
		},
	});
